import React from "react";
import logo from "../../assets/white-logo.svg";

export default () => {
  return (
    <div className="intro">
      <div className="imageContainer hero-container secondary">
        <div className="logoContainer">
          <img src={logo} alt="logo" className="logo" />
        </div>
        <div className="gradient" />
      </div>
      <div className="intro-container"></div>
    </div>
  );
};
